import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../../../../common/modal-dialog/modal-dialog.component';
import agent from '../../../../api/agent';
import { CodeStringWrapper, QrcodeWrapper } from '../details-sidebar.styles';
import Image from '../../../../common/image-component/image.component';
import { useIsMobile } from '../../../../hooks/use-is-mobile.hook';
import { ReactComponent as CopyIcon } from '../../../../assets/copy-icon.svg';
import { copyToClipboard } from '../../../../utils/generic/generic.utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  code: string;
  shipmentId: number | string;
}

const CodeGenerationDialog = ({
  isOpen = false,
  onClose,
  code,
  shipmentId,
}: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const codeObjectUrlRef = useRef<string | null>(null);
  const [codeImageUrl, setcodeImageUrl] = useState<string | null>(null);

  const updatecodeImageUrl = useCallback((nextUrl: string | null) => {
    if (codeObjectUrlRef.current) {
      URL.revokeObjectURL(codeObjectUrlRef.current);
    }

    codeObjectUrlRef.current = nextUrl;
    setcodeImageUrl(nextUrl);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    let isCancelled = false;
    updatecodeImageUrl(null);

    agent.Shipment.getBarcodeFile(shipmentId)
      .then((codeFile) => {
        if (isCancelled) return;
        updatecodeImageUrl(URL.createObjectURL(codeFile));
      })
      .catch(() => {
        if (isCancelled) return;
        // setIscodeImageLoading(false);
        updatecodeImageUrl(null);
      });

    return () => {
      isCancelled = true;
    };
  }, [isOpen, shipmentId, updatecodeImageUrl]);

  useEffect(() => {
    if (isOpen) return;

    updatecodeImageUrl(null);
  }, [isOpen, updatecodeImageUrl]);

  useEffect(
    () => () => {
      if (codeObjectUrlRef.current) {
        URL.revokeObjectURL(codeObjectUrlRef.current);
      }
    },
    []
  );

  const successMessage = t('parcel_number_is_copied');

  return (
    <ModalDialog
      width='auto'
      isOpen={isOpen}
      onClose={onClose}
      displayButtons={false}>
      <QrcodeWrapper>
        <Image
          src={codeImageUrl ?? undefined}
          alt='QR code'
          width={isMobile ? '24rem' : '30rem'}
          height={isMobile ? '24rem' : '30rem'}
          borderRadius='10px'
        />
        <CodeStringWrapper
          onClick={() =>
            copyToClipboard({
              text: code,
              successMessage,
            })
          }>
          <p>{code}</p>
          <CopyIcon />
        </CodeStringWrapper>
      </QrcodeWrapper>
    </ModalDialog>
  );
};
export default CodeGenerationDialog;
